export const manageBannerStyle = {
  uploadImage: {
    border: "1px dashed #25cff2",
  },
  courseCardTag: {
    color: "rgb(255, 255, 255)",
    background: "rgb(253, 179, 6)",
    // display: "flex",
    // alignItems: "center",
    // gap: "4px",
  },
  insideBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#25cff2",
  },
  bannerImageCont: {
    width: "200px",
    height: "150px",
  },
  imgStateText: {
    fontSize: "14px",
    fontStyle: "normal",
    fontFamily: "inherit",
    fontWeight: "600",
    lineHeight: "16px",
    paddingLeft: "11px",
    color: "rgb(239, 105, 30)",
  },
  selectField: {
    width: "100%",
    border: "1px solid rgb(216, 224, 240)",
    // borderRadius: "16px",
    fontSize: "16px",
    backgroundColor: "white",
    outline: "none",
    backgroundPosition: "10px 10px",
    backgroundRepeat: "no-repeat",
    padding: "12px 18px 11px 13px",
    lineHeight: "20px",
    // boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
  },
  courseInput: {
    width: "100%",
    border: "1px solid rgb(216, 224, 240)",
    borderRadius: "5px",
    fontSize: "16px",
    backgroundColor: "white",
    outline: "none",
    backgroundPosition: "10px 10px",
    backgroundRepeat: "no-repeat",
    padding: "10px 12px",
    lineHeight: "24px",
    // boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
  },
};
